import BaseService from './base'

export default class AllmapService extends BaseService {
  private serviceName = 'spa/allmap'
  constructor(config: ServiceInitParams) {
    const { timeout, baseURL, appId } = config
    super({ timeout, baseURL, appId })
  }

  public getStoresNearBy(
    lat: number,
    lng: number,
    rad = 100
  ): Promise<StoreInfo[]> {
    if (!lat || !lng) {
      throw new Error('lat and lng are required')
    }
    const queryString = new URLSearchParams({
      at: `${lat.toString().slice(0, 10)},${lng.toString().slice(0, 10)}`, //  latitude or longitude can contain not more than 10 characters.
      rad: rad.toString(),
    })
    return this.request<StoreInfoResponse>(
      `${this.serviceName}/v1/stores/nearme?${queryString.toString()}`,
      { method: 'GET' }
    ).then((response) => response.data)
  }
}
